(() => {
  angular
    .module('app.report')
    .controller('ReachReportController', ReachReport);

  ReachReport.$inject = [
    '$scope',
    '$filter',
    '$timeout',
    'Report',
    'ChartService'
  ];

  function ReachReport(
    $scope,
    $filter,
    $timeout,
    Report,
    ChartService
  ) {
    document.removeEventListener('visibilitychange', updateDataOnVisible);

    let isVisibilityWatcherSetted = false;

    const vm = this;
    const { report } = $scope.$parent;
    const isIntegratedCampaign = () => report.campaign.type === 'integrated';
    const cache = {
      report: null,
      chart: {
        options: ChartService.getBaseChartConfig(),
        data: null,
      },
    };

    const sources = [{
      key: 'total',
      name: 'Total',
      color: '#000000',
    }, {
      key: 'audiencereport',
      name: 'AudienceReport',
      color: '#16d6d8',
    }, {
      key: 'facebook',
      name: 'Facebook',
      color: '#4469B0',
    }, {
      key: 'youtube',
      name: 'Youtube',
      color: '#FF0000',
    }];

    vm.getProvider = provider => sources.find(item => item.key === provider).name;

    vm.details = null;
    vm.getReportItem = ri => report.campaign.reportItems.find(item => item.evid === ri.evid);
    vm.isTVEnabled = reportItem => {
      const ri = vm.getReportItem(reportItem);
      return ri && ri.properties.featureTVEnabled === 1;
    };

    vm.getSampleSizeErrorLevel = reportItem => reportItem.nStatus;
    vm.getSampleSizeErrorTooltip = reportItem => {
      if (!reportItem) {
        return '';
      }

      switch (vm.getSampleSizeErrorLevel(reportItem)) {
        case 'warning': return `Sample size is ${reportItem.n}. That seems a bit low!`;
        case 'error': return 'No sample size - please check the implementation!';
        default: return `Sample size is ${$filter('number')(reportItem.n)}`;
      }
    };
    vm.isStandard = () => report.campaign && report.campaign.type === 'standard';

    initChart();
    activate();
    function activate() {
      report.isCampaignLoading = true;
      report.subActivate = activate;

      report.reportPromise
        .then(({ data }) => {
          cache.report = data;

          vm.detailsLoaded = true;
          vm.weeklyLoaded = true;
        })
        .then(() => {
          report.isCampaignLoading = false;
          report.isCampaignLoaded = true;

          if (document.visibilityState === 'visible') {
            updateDataOnVisible();
          } else {
            if (!isVisibilityWatcherSetted) {
              document.addEventListener('visibilitychange', updateDataOnVisible);
              isVisibilityWatcherSetted = true;
            }
          }
        });
    }

    function updateDataOnVisible() {
      if (document.visibilityState !== 'visible') {
        return false;
      }

      if (cache.report) {
        vm.weekly = cache.report.weekly;

        vm.weekLabels = _.pluck(_.values(vm.weekly), 'week');

        // adjust the build up value to 98 if over
        _.map(vm.weekly, item => item.reach = item.reach > 98 ? 98 : item.reach);
      }

      updateChart();
      updateTable();
    }

    function updateTable() {
      if (!cache.report) {
        return false;
      }

      const reachDetails = vm.isStandard() ? cache.report : cache.report.reach;
      if (vm.details) {
        const allReachDetails = [
          ...reachDetails.reportItems,
          reachDetails.totals,
        ];

        allReachDetails.forEach(item => {
          const row = [
            ...vm.details.reportItems,
            vm.details.totals,
          ].find(curr => (
            (curr.tailcode && (curr.tailcode === item.tailcode)) ||
            (curr.fusionId && (curr.fusionId === item.fusionId)) ||
            (curr.name === 'Total')
          ));

          // update existing rows for splash animation
          if (row) {
            row.reach = item.reach;
            row.frequency = item.frequency;
            row.reachContribution = item.reachContribution;
          }
      });

        // delay for odometer splash animation
        $timeout(() => {
          vm.details = reachDetails;
        }, TIME.DATA_SPLASH);
      } else {
        vm.details = reachDetails;
      }

      // invalidate table after splash animation finished
      $timeout(() => {
        const dtTable = $('#tableReachDetails').DataTable();
        dtTable.cells().invalidate('dom').draw();
      }, TIME.DATA_SPLASH);
    }

    function initChart() {
      vm.weekly = [];
      vm.reachBuildupChartConfig = {
        series: [],
      };
    }

    function updateChart() {
      const series = [];

      vm.reachBuildupChartConfig.options = getCustomChartOptions(cache.chart.options);

      if (isIntegratedCampaign()) {
        if (!cache.report) {
          return false;
        }

        const { reach } = cache.report;
        const total = sources.find(item => item.key === 'total');
        const totalData = _.pluck(_.values(reach.weekly), 'reach');
        series.push({
          data: totalData,
          name: 'Total unique reach',
          color: total.color,
        });

        reach.reportItems.forEach(({ providerId, weekly }, index) => {
          const source = sources.find(item => item.key === providerId);
          const itemData = _.pluck(_.values(weekly), 'reach');
          const drawData = totalData.map(() => 0);
          drawData.splice(0, itemData.length, ...itemData);

          series.push({
            data: drawData,
            name: source.name,
            color: source.color,
          });
        });
      } else {
        series.push({
          data: _.pluck(_.values(vm.weekly), 'reach'),
          name: report.campaign.hasCustomTargeting ? 'Coverage' : 'Reach',
          color: cache.chart.options.colors[0],
        });
      }

      vm.reachBuildupChartConfig.series = series;
    }

    function getCustomChartOptions(options) {
      return angular.merge(options, {
        tooltip: {
          formatter() {
            const margin = week => _.pluck(vm.weekly, 'marginal')[week];
            const row = (color, name, val) => (`
              <tr>
                <td class="td-left">
                  <span class="bullet bullet-small" style="background-color:${color};"></span>
                  ${name}:
                </td>
                <td class="td-right">${$filter('customNumber')(val)}</td>
              </tr>`
            );

            const rows = points => {
              return points.reduce((rows, point) => {
                const { color, name } = point.series;
                return `${rows} ${row(color, name, `${point.y}%`)}`;
              }, '');
            }

            const rowsExtra = week => (
              isIntegratedCampaign() ? '' : `
                ${row('', 'TRP', vm.weekly[week]['trp'])}
                ${row('', 'Incremental reach', `${margin(week)}%`)}`
            );

            const tooltip = (points, week) => (`
              <h4>week ${vm.weekLabels[week]}</h4>
              <div class="highcharts-tooltip-outer">
                <table class="highcharts-tooltip-inner">
                  ${rows(points)}
                  ${rowsExtra(week)}
                </table>
              </div>`
            );

            return tooltip(this.points, this.x);
          }
        },
        xAxis: {
          labels: {
            formatter() {
              return `Week ${vm.weekLabels[this.value]}`;
            }
          }
        },
      });
    }
  }
})();
